import {zhouyi} from "../guastat/zhouyi.js"
import Sha256 from "./sha256.js";
import { daYanArray } from "./allNumbers.js";

export function number2code (numStr) {
    // numStr is a 6-char long string consists of [6, 7, 8, 9]
    // 6, 8 --> 0
    // 7, 9 --> 1

    let codeStr = ""
    for (let i=0; i<numStr.length; i++) {
        if (numStr[i] % 2 == 0) {
            codeStr = codeStr + '0'
        } else {
            codeStr = codeStr + '1'
        }
    }
    return codeStr
}

export function findGua(codeStr) {

    if (codeStr.length == 6) {
        return zhouyi[codeStr].fullName
    } else {
        return ""
    }
}

export function autoQi() {
    start = 50
    return "678976"
}

/*
function: stickReduction
This function is key to create yao number by 
大衍之數五十，其用四十有九，分而為二以象兩，掛一以象三，揲之以四以象四時，歸奇於扐以象閏，五歲再閏，故再扐而後掛。

Do 3 times and get the number of the remaining 4's bundles
Input: initArray: length 49, shuffled.

Algorithm:
- imitate the Da Yan method. I am not going to pick a split point across the whole array.
  I am going to randomly pick a split point from the middle section.
- The middle section for each iteration is about the same, the middle 24. 
- Push (bundleCount) into Yao array: the number [6|7|8|9] of the remaining 4's bundles (for a Yao)
- Return numStr (6 yao string)
*/
export function stickReduction(mergedSeed) {
    var stepMiddleRange = {
        49: [11, 40],  // 40 - 11 = 29
        44: [10,35],   // 35 - 10 = 25
        40: [9,32],    // 32 - 9  = 23
        36: [8,29],    // 29 - 8  = 21
        32: [7,26],    // 26 - 7  = 19
        28: [6,23]     // 23 - 6  = 17
    }

    var initArray = 0;
    var initArrayLength = 0;
    var timestamp;
    var timestamp_int;
    var timestamp_date_str;
    var yaoCount = 0;
    var splitCount = 0;
    var currentArray = [];
    var currentArrayLength = 0
    var currentMiddleRange = []
    var newMergedSeed = ""
    var kickIndex = 0
    var leftArray = []
    var rightArray = []
    var newLeftArray = [];
    var newRightArray = [];
    var newMergedArray = [];
    var tmpArray = [];
    var leftArrayLength = 0;
    var leftRemainder = 0;
    var rightArrayLength = 0;
    var rightRemainder = 0;
    var kickLeft = 0;
    var kickRight = 0;
    var bundleCount = 0;
    var numStr = "";
    
    //alert("initArray is " + initArray.toString())
    //alert("Starting Yao: initArray length is " + initArray.length)
    tmpArray = shuffleArray(daYanArray);
    tmpArray.pop(); // 掛一 get rid of the last one
    initArray = [].concat(tmpArray);
    initArrayLength = initArray.length;

    for (yaoCount = 1; yaoCount <= 6; yaoCount++ ) {
        // Initialize bundleCount = 0 for each new yao and the currentArray to be 49
        bundleCount = 0;
        currentArray = [].concat(initArray);
        currentArrayLength = initArrayLength;
        // splite 3 times for each yao and add boundleCount to numStr
        for (splitCount = 1; splitCount <= 3; splitCount++ ) {

            //alert(splitCount + " : currentArray length is : " + currentArrayLength )
            if (currentArrayLength == 49) currentMiddleRange = stepMiddleRange[49]
            else if (currentArrayLength == 44)  currentMiddleRange = stepMiddleRange[44]
            else if (currentArrayLength == 40) currentMiddleRange = stepMiddleRange[40]
            else if (currentArrayLength == 36)  currentMiddleRange = stepMiddleRange[36]
            else if (currentArrayLength == 32)  currentMiddleRange = stepMiddleRange[32]
            else currentMiddleRange = stepMiddleRange[28]
            
            // Get new timestamp
            timestamp = Date.now();
            timestamp_int = parseInt(timestamp);
            timestamp_date_str = new Date(timestamp_int);
            //kickIndex = getRndInteger(currentMiddleRange[0], currentMiddleRange[1]);
            newMergedSeed = timestamp_date_str + mergedSeed + yaoCount + splitCount;
            kickIndex = getHashKick(timestamp_int, currentArrayLength, newMergedSeed);
            //alert(splitCount + " : kickIndex is " + kickIndex);
            // By spliting into two arrays, kick out the kickIndex at the same time
            leftArray = currentArray.slice(0, kickIndex);
            rightArray = currentArray.slice(kickIndex + 1);

            // process left and right array seperately
            // LEFT:
            leftArrayLength = leftArray.length;
            leftRemainder = leftArrayLength % 4;
            tmpArray = shuffleArray(leftArray);
            //alert("## 1 ## tmpArray:" + tmpArray.toString());
            // kick things out
            if (leftRemainder != 0) kickLeft = leftRemainder;
            else kickLeft = 4;
            for (var i = 0; i < kickLeft; i++) tmpArray.pop();

            // newLeftArray is now shorter by kickNum (4, 3, 2 or 1 sticks)
            newLeftArray = [].concat(tmpArray);

            // alert("## 1 ## newLeftArray: " + newLeftArray.toString());

            // RIGHT:
            rightArrayLength = rightArray.length;
            rightRemainder = rightArrayLength % 4;
            tmpArray = shuffleArray(rightArray);
            //alert("## 1 ## tmpArray:" + tmpArray.toString());
            // kick things out
            if (rightRemainder != 0) kickRight = rightRemainder;
            else kickRight = 4;
            for (var i = 0; i < kickRight; i++) tmpArray.pop();

            // newRightArray is now shorter by kickNum (4, 3, 2 or 1 sticks)
            newRightArray = [].concat(tmpArray);

            //alert(splitCount + ": Total kickNum: " + (kickLeft + kickRight + 1));
            // alert("## 1 ## newRightArray: " + newRightArray.toString());

            newMergedArray = newLeftArray.concat(newRightArray);
            //alert("newMergedArray Length:" + newMergedArray.length);
            //alert("newMergedArray : " + newMergedArray);

            // 3, the remaining last 2 sub-arrays should be bundles of 4's. See how many bundles.
            bundleCount = newMergedArray.length / 4;
            //alert(splitCount + " : bundleCount is : " + bundleCount);

            // Now, need to rebuild the currentArray for the next round
            currentArray = [].concat(newMergedArray);
            currentArrayLength = currentArray.length;
        }
        numStr = numStr + bundleCount;
        //alert("numStr : " + numStr);
    }
    //alert("自動起卦爻數 : " + numStr);
    return numStr;
}


//*****************************/
// Internal functions
//*****************************/
function shuffleArray(originalArray) {
    let array = [].concat(originalArray);
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

  return array;
}

export function hashMe(e) {
    for(var r=0,i=0;i<e.length;i++) {
        r = (r<<5)-r+e.charCodeAt(i);
        r&=r;
    }
    return r
};

// This is a basic RNG from a range for testing only
// returns a random number between min (included) and max (excluded):
function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }

// This is the key range RNG with merged seeds
function rngWithSeedRange (min, max, mergedSeed) {
   
}

function getHashKick(qigua_timestamp_int, arrayLength, newMergedSeed) {
    var lengthStartIndex = {
        49: 11,  // 40 - 11 = 29
        44: 10,   // 35 - 10 = 25
        40: 9,    // 32 - 9  = 23
        36: 8,    // 29 - 8  = 21
        32: 7,    // 26 - 7  = 19
        28: 6     // 23 - 6  = 17
    }
    var base_range = {
        49: 29,
        44: 25,
        40: 23,
        36: 21,
        32: 19,
        28: 17,
    };

    var hash = Sha256.hash(newMergedSeed);
    var hash_int = parseInt("0x" + hash);
    var hash_quotien = hash_int / qigua_timestamp_int;
    var index = hash_quotien % base_range[arrayLength];
    var kickIndex =  index + lengthStartIndex[arrayLength];

    return kickIndex;

}


// step1 to step 3 array in and out to become the input of a Yao
// export function inArrayOutYao(qigua_timestamp_int, ina, mergedSeed, yao_cnt, split_cnt) {
//     // Get the seed and start to generate Gua
//     // let leftArrayLength = 0;
//     // let leftRemainder = 0;
//     // let rightArrayLength = 0;
//     // let rightRemainder = 0;
//     // let kickNum = 4;
//     // let newLeftArray = [];
//     // let newRightArray = [];
//     // let newMergedArray = [];
//     var yao = 0;

//     // 1, kick 1 out from the daYanArray: 大衍之數五十，其用四十有九
//     //    Method: shuffleArray(daYanArray), then pop the last one out to form a new shorter array
//     //            and shullfe again.
//     var tmpArray = shuffleArray(ina);
//     var initArray = [];
//     //var initArrayLength = 0;
//     //alert("Shuffled array is " + tmpArray.toString());
//     //tmpArray.pop(); // get rid of the last one
//     initArray = [].concat(tmpArray);
//     //alert("tmpArray is " + tmpArray.toString());
//     //alert("initArray is " + initArray.toString());

//     // 2, pick an index from the middle 24 items. 分而為二以象兩
//     //    This picked index will be kicked out later. 掛一以象三
//     //    Use this index to slice the array into 2 sub-arrays.
//     //    揲之以四以象四時，歸奇於扐以象閏，五歲再閏，故再扐而後掛。…四營而成易，十有八變而成卦…
//     //    Each sub-array will be suffled.
//     //    The length % 4 to kick out the remainders.
//     //    The remaining 2 sub-arrays will be contacted and shuffled again.
//     //    ***!!!! ==> Do #2 three times.
//     //initArrayLength = initArray.length;
//     //alert("initArray length : " + initArrayLength);

//     // **************************************************
//     // Now do 3 times of stick reduction. return the number of remaining 4's bundles
//     // **************************************************
//     yao = stickReduction(qigua_timestamp_int, initArray, mergedSeed, yao_cnt, split_cnt)

//     return yao

//     /*
//     //let step1MiddleRange = [13, 38]; // middle 25 items for step1
//     let kickIndex = getRndInteger(13, 38);  // step1MiddleRange (13, 38)
//     //alert("kickIndex is " + kickIndex);
//     let leftArray = step1Array.slice(0, kickIndex);
//     let rightArray = step1Array.slice(kickIndex + 1);
//     // alert("step1Array: " + step1Array.toString());
//     // alert("leftArray: " + leftArray.toString());
//     // alert("rightArray: " + rightArray.toString());

//     // process left and right array seperately
//     // LEFT:
//     leftArrayLength = leftArray.length;
//     leftRemainder = leftArrayLength % 4;
//     tmpArray = shuffleArray(leftArray);
//     //alert("## 1 ## tmpArray:" + tmpArray.toString());
//     // kick things out
//     kickNum = 4;
//     if (leftRemainder != 4) kickNum = leftRemainder;
//     for (let i = 0; i < leftRemainder; i++) tmpArray.pop();
//     newLeftArray = tmpArray;

//     // alert("## 1 ## kickNum:" + kickNum);
//     // alert("## 1 ## newLeftArray: " + newLeftArray.toString());

//     // RIGHT:
//     rightArrayLength = rightArray.length;
//     rightRemainder = rightArrayLength % 4;
//     tmpArray = shuffleArray(rightArray);
//     //alert("## 1 ## tmpArray:" + tmpArray.toString());
//     // kick things out
//     kickNum = 4;
//     if (rightRemainder != 4) kickNum = rightRemainder;
//     for (let i = 0; i < rightRemainder; i++) tmpArray.pop();
//     newRightArray = tmpArray;

//     // alert("## 1 ## kickNum:" + kickNum);
//     // alert("## 1 ## newRightArray: " + newRightArray.toString());

//     newMergedArray = newLeftArray.concat(newRightArray);
//     alert("newMergedArray Length:" + newMergedArray.length);
//     // alert("newMergedArray : " + newMergedArray);

//     // 3, the remaining last 2 sub-arrays should be bundles of 4's. See how many bundles.
//     */
    
// }